<template>
  <div class="setting">
    <otp-change-password-modal
      v-if="options[0].modal"
      @closeModal="closeE"
      @submit="submitted($event)"
      :qr-link="qrLink"
      :two-step="modal"
    />
    <google-otp
      v-if="options[1].modal"
      @closeModal="closeG"
      @submit="submitted($event)"
      :qr-code="qrCode"
      :two-step="modal"
    />
    <change-pass v-if="pass === true" @close="pass = false" />
    <div class="header">تنظیمات</div>
    <div class="content">
      <div class="left-row">
        <div class="top">
          <span class="title">شناسه دوعاملی</span>
          <p>
            ﺟﻬﺖ ورود ﺑﻪ ﺣﺴﺎب ﮐﺎرﺑﺮی و درﺧﻮاﺳﺖ ﺑﺮداﺷﺖ و تغییر رمز عبور، یکی از
            راه های زیر را برای شناسه دوعاملی انتخاب کنید
          </p>
          <!-- <div class="radio">
            <span :class="{'active-radio' : otpSelect === 'ایمیل'}" @click="otpSelect = 'ایمیل'" class="inputRadio">ایمیل</span>
            <span :class="{'active-radio' : otpSelect === 'گوگل'}"  @click="otpSelect ='گوگل'"
                  class="inputRadio">گوگل</span>
          </div> -->

          <!-- <div class="radio" >
  <span v-for="(option,index) in options" :key="index" class="inputRadio" :class="{ 'active-radio' : twoStep == option.model}">{{option.title}}</span>
</div> -->

          <form
            class="radio"
            @change="showModal(options.findIndex((e) => e.model === twoStep))"
          >
            <div
              v-for="(options, index) in options"
              :key="index"
              class="radio-btns"
            >
              <input type="radio" v-model="twoStep" :value="options.model" />
              <label>
                {{ options.title }}
              </label>
            </div>
          </form>
        </div>
        <div class="bottom">
          <span class="title">تغییر رمز عبور</span>
          <div class="change-password">
            <span>از طریق این گزینه رمز عبور خود را تغییر دهید</span>
            <button @click="pass = true" class="blue-btn">
              تغییر رمز عبور
            </button>
          </div>
        </div>
      </div>
      <div class="right-row">
        <step-auth />
      </div>
    </div>
  </div>
</template>

<script>
import StepAuth from "./dashborad/step-auth";
import OtpChangePasswordModal from "./modal/otp-change-password-modal";
import GoogleOtp from "./modal/google-otp";
import ChangePass from "./modal/change-pass";

export default {
  name: "the-setting",
  components: { ChangePass, GoogleOtp, OtpChangePasswordModal, StepAuth },
 data() {
        return {
          pass:false,
            twoStep: this.state.towStepAuthenticationType,
            qrCode: '',
            qrLink: '',
            mobile: '',
            completedModal: false,
            completedText: '',
            modal: '',
            options: [{
                    title: "ایمیل",
                    modal: false,
                    model: 'EMAIL'
                },
   
                {
                    title: "شناسایی دو عاملی گوگل",
                    modal: false,
                    model: 'GOOGLE_AUTHENTICATOR'
                }
            ]
        }
    },
  /*TODO: fetch data from server
  
DEBUG: debugging Functions and Datas in settings P
  
  */
  methods: {
    //   OpenModal(index) {
    //       this.options[index].modal=true
    //   },
    closeG(value) {
      this.options[1].modal = value;
    },

    closeE(value) {
      this.options[0].modal = value;
    },
    async getTwoStepAuth() {
      this.twoStep = this.state.userInfo.towStepAuthenticationType;
    },
    async showModal(index) {
      this.state.loading = true;
      const res = await this.$axios
        .post(
          `/users/send-verification-code?twoStepAuthorization=${this.twoStep}`
        )
        .catch(() => {
          this.getTwoStepAuth();
        });
      if (res) {
        this.mobile = res.baseDTO.starTwoStepAuthentication || "";
        this.qrCode = res.baseDTO.file || "";
        this.qrLink = res.baseDTO.qrCodeLink || "";
        this.options[index].modal = true;
      }
      this.getTwoStepAuth();
    },
    async submitted(e) {
      this.completedText = e;
      await this.$error("", e, "success");
      await this.$getuserInfo();
      this.getTwoStepAuth();
    },
  },
  mounted() {
    this.getTwoStepAuth();
  },
};
</script>

<style lang="scss" scoped>
.radio-btns {
  display: flex;
  align-items: center;
  gap: 10px;
}

label {
  color: white;
}
input[type="text"] {
  height: 100%;
  align-self: center;
  border: none;
  border-bottom: 1px solid white;
  color: white;
  font-size: 14px;
  font-weight: bold;
  background: none;
  outline: none;
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
}
.panel-box {
  background: linear-gradient(180deg, #091222 0%, #0a1425 100%);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  padding: 35px;
}

.header {
  font-size: clamp(16px, 2vw, 22px);
  color: #ffffff;
  width: 100%;
  justify-content: flex-start;
  display: flex;
  margin: 40px 0;
}

.content {
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
  flex-wrap: wrap;

  .right-row {
    @extend .panel-box;
    flex-grow: 1;
    flex-basis: 100px;
    height: fit-content;
  }

  .left-row {
    display: flex;
    flex-direction: column;
    gap: 25px;
    flex-grow: 1;
    flex-basis: 100px;

    .top {
      @extend .panel-box;
      display: flex;
      flex-direction: column;
      gap: 18px;
      text-align: right;

      .title {
        color: #ffffff;
        font-size: 14px;
        font-weight: bold;
      }

      p {
        color: #ffffff;
        font-size: 14px;
      }

      .radio {
        display: flex;
        flex-direction: row;
        justify-content: start;
        gap: 100px;
        flex-wrap: wrap;

        .inputRadio {
          color: rgba(215, 200, 200, 1);
          font-size: 12px;
          position: relative;

          &:first-child {
            right: 20px;
          }

          &:before {
            content: "";
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 1px solid rgba(215, 200, 200, 1);
            position: absolute;
            left: 37px;
            cursor: pointer;
          }
        }

        .active-radio {
          @extend .inputRadio;

          &:before {
            background-color: rgba(4, 178, 162, 1);
            border: none;
            width: 13px;
            height: 13px;
          }
        }
      }
    }
  }

  .bottom {
    @extend .panel-box;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      display: flex;
      justify-content: flex-start;
      color: #ffffff;
      font-weight: bold;
    }

    .change-password {
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      font-size: clamp(12px, 2vw, 16px);
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;

      button {
        width: 104px;
        height: 32px;
      }
    }
  }
}

@media (max-width: 350px) {
  .right-row {
    padding: 10px !important;
  }
}
</style>
